import { useAppTranslation, useBackToShop } from "@/utils";
import { InfoCircleFilled, PhRArrowCounterClockwise } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";

interface PayUnAvailableProps {
  onRetry?: () => void;
  onRetryLoading?: boolean;
  shopName?: string;
  backToShop?: () => void;
  hideBack?: boolean;
}
const PayUnAvailable = (props: PayUnAvailableProps) => {
  const { t } = useAppTranslation();

  const { backToShop, shopName } = useBackToShop();

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!" gap={"middle"} align="center">
      <Flex vertical align="center" gap={"large"} className="tw:my-auto tw:w-full">
        <InfoCircleFilled width={80} className="tw:fill-color-warning" />
        <Flex vertical gap={"small"} align="center" className="tw:mt-1!">
          <Typography.Title level={5} className="tw:m-0! tw:text-center!">
            {t("pay.unAvailableContent")}
          </Typography.Title>
        </Flex>
        {props.onRetry ? (
          <Button
            icon={<PhRArrowCounterClockwise width={14} height={14} />}
            type="link"
            onClick={() => {
              if (!props.onRetry) return;
              props.onRetry();
            }}
            loading={props.onRetryLoading ?? false}
          >
            {t("common.retry")}
          </Button>
        ) : null}
      </Flex>

      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        {props.hideBack ? null : (
          <Button
            block
            onClick={() => {
              if (props.backToShop) {
                backToShop();
              } else {
                backToShop();
              }
            }}
          >
            {props.shopName || shopName
              ? t("common.returnTo", { name: props.shopName ?? shopName })
              : t("common.returnToShop")}
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default PayUnAvailable;
